<template>
  <img src="../../../assets/img/avatars/avatar6.jpg" alt="avatar6">
</template>
